import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Fragment } from 'react';
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { twMerge } from 'tailwind-merge';
import Button from './Button';
import { RowTabStopContext } from './row-tab-stop';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SimpleModalContent = function SimpleModalContent(_ref) {
  var open = _ref.open,
    header = _ref.header,
    children = _ref.children,
    footer = _ref.footer,
    className = _ref.className,
    onClose = _ref.onClose;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var _useModal = useModal(),
    previousModal = _useModal.previousModal;
  var handleClose = function handleClose() {
    onClose === null || onClose === void 0 || onClose();
    previousModal === null || previousModal === void 0 || previousModal();
  };
  return /*#__PURE__*/_jsx(Transition, {
    show: open,
    as: Fragment,
    children: /*#__PURE__*/_jsxs(Dialog, {
      "static": true,
      as: "div",
      className: "relative z-20",
      onClose: handleClose,
      children: [/*#__PURE__*/_jsx(TransitionChild, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/_jsx("div", {
          className: "fixed inset-0 bg-gray-900 opacity-70 transition-opacity dark:bg-gray-100"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "fixed inset-0 z-30 w-screen overflow-y-auto",
        children: /*#__PURE__*/_jsx("div", {
          className: "flex min-h-full items-center justify-center p-4 text-center",
          children: /*#__PURE__*/_jsx(TransitionChild, {
            as: Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            enterTo: "opacity-100 translate-y-0 sm:scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
            children: /*#__PURE__*/_jsxs(DialogPanel, {
              className: twMerge('shadow-base relative flex max-h-[80dvh] transform flex-col overflow-hidden rounded-sm bg-white text-start transition-all dark:bg-gray-200', className),
              "data-test-id": "modal-dialog",
              children: [/*#__PURE__*/_jsxs("header", {
                className: twMerge('flex h-15 shrink-0 items-center px-4', header ? 'justify-between' : 'justify-end'),
                children: [header ? /*#__PURE__*/_jsx(DialogTitle, {
                  as: "h1",
                  className: "text-2xl font-bold lowercase first-letter:uppercase",
                  children: header
                }) : null, /*#__PURE__*/_jsx(Button, {
                  iconKey: "close",
                  color: "icon",
                  "aria-label": i18next.t('close'),
                  onClick: handleClose,
                  "data-test-id": "modal-close-button"
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: "scrollbar flex-1 overflow-y-auto px-4",
                children: children
              }), footer && /*#__PURE__*/_jsx("div", {
                className: "shrink-0 px-4 pb-4",
                children: footer
              })]
            })
          })
        })
      })]
    })
  });
};

// Context passes through portals, so a dialog that a list row opens would
// otherwise take the row's Tab stop state.
var SimpleModal = function SimpleModal(props) {
  return /*#__PURE__*/_jsx(RowTabStopContext.Provider, {
    value: undefined,
    children: /*#__PURE__*/_jsx(SimpleModalContent, _objectSpread({}, props))
  });
};
export default SimpleModal;